/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["iframe[_ngcontent-%COMP%]{width:100%;height:calc(100vh - 215px);min-height:700px;border:0}"];
export { styles as styles };
//# sourceMappingURL=game-rules.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/game-rules/game-rules.component.scss.shim.ngstyle.js
// module id = 1722
// module chunks = 27 28 29